import { FormSection } from '../../components/ui/FormSection';
import type { VenueStatus } from '@wineryxplorer/shared';

interface AdminTabProps {
  status: VenueStatus;
  onStatusChange: (value: VenueStatus) => void;
}

export const AdminTab = ({ status, onStatusChange }: AdminTabProps) => (
  <div>
    <FormSection
      title="Administrative Settings"
      description="These settings are only visible to site administrators and super administrators."
    >
      {/* Publication Status — nested, so it does not draw a second rule. */}
      <FormSection title="Publication Status" titleAs="h3" divider={false} className="mt-0">
        <div className="max-w-md">
          <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
            Status *
          </label>
          <select
            id="status"
            value={status}
            onChange={(e) => onStatusChange(e.target.value as VenueStatus)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
          >
            <option value="published">Published</option>
            <option value="draft">Draft</option>
          </select>
          <p className="mt-2 text-sm text-gray-500">
            <strong>Published:</strong> Venue is visible to all users in public listings
          </p>
          <p className="mt-1 text-sm text-gray-500">
            <strong>Draft:</strong> Venue is only visible to administrators. Use this for venues that are still being set up.
          </p>
        </div>
      </FormSection>
    </FormSection>
  </div>
);
